export class NewRequestService {
    requestId: number;
    requestServiceId: number;
    requestServiceIds: number[];
    serviceId: number;
    serviceName: string;
    serviceCategoryId: number;
    serviceCategoryName: string;
    serviceTypeId: number;
    serviceTypeName: string;
    serviceModeName: string;
    articleNumber: string;
    cost: number;
    fullCost: number;
    isDone: boolean;
    isDefault: boolean;
    discount: number;
    discountPrimary: number;
    costCenterId: number;
    costCenterName: string;
    count: number;
    isPrepaidService: boolean;
    parentRequestServiceId: number;
}